// API Configuration
// Staging/Production: set REACT_APP_API_BASE_URL at build time (e.g. in Azure DevOps pipeline).
// Local: set REACT_APP_API_MODE=local to use localhost.
const API_BASE_URL =
  process.env.REACT_APP_API_MODE === 'local'
    ? 'http://localhost:5000'
    : (process.env.REACT_APP_API_BASE_URL || 'https://meprobackend-efe3e2d4gucvcddy.eastus2-01.azurewebsites.net');

export default API_BASE_URL;

